import request from './request';
import type { tCurrency } from '@/types/index';

// 修改昵称
export const editNickname = ({ nickname, countryCode, phoneNumber }: { nickname: string, countryCode?: string, phoneNumber?: string }) =>
  request({
    url: '/carbon-auth/private/user/center/user/edit',
    method: 'POST',
    data: { nickname, countryCode, phoneNumber }
  });


// 用户详情
export const getUserDetail = () =>
  request({
    url: '/carbon-auth/private/user/center/user/detail',
    method: 'GET',
  });

// 获取钱包
export const getWallet = ({ currency }: { currency: tCurrency }) =>
  request({
    url: '/carbon-wallet/private/user/wallet/user/detail',
    method: 'GET',
    params: {
      currency
    }
  });

// 重置密码
export const resetPw = ({ originalPassword, newPassword }: { originalPassword: string, newPassword: string }) =>
  request({
    url: '/carbon-auth/private/user/center/reset/pwd',
    method: 'POST',
    data: {
      originalPassword,
      newPassword
    }
  });